exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".detail-title[data-v-9d284090]{font-size:16px;font-weight:500;color:#333}.title-margin[data-v-9d284090]{margin:40px 0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-9d284090&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentSit/EquipmentSitDetail.vue
// module id = 611
// module chunks = 0